































































































































































































































































































import { Component, Prop } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import Ajax from "@/lib/ajax";
import Order from "@/store/entities/booking/order";
import moment from "moment";
import util from "@/lib/util";

class PostData {
  orderNum: string = moment().format("YYYY-MM-DD HH:mm:ss");
  courtId: number | string = 0;
  productId: number | null = 0;
  name: string = "";
  orderType: number = 0;
  orderState: number = 0;
  teeTime: any = moment().format("YYYY-MM-DD HH:mm:ss");
  personCount: number = 1;
  personNames: string = "";
  linkMan: string = "";
  phoneNumber: string = "";
  usedCouponNewcomer: boolean = false;
  usedCourtCoupon: boolean = false;
  usedFunds: boolean = false;
  supplierId: number | null = null;
  payeeId: number | null = null;
  price: number = 0;
  payeeType: number = 0;
  supplierPayType: number = 0;
  adminRemark: string = "";
  payMethod: string = "";
}
@Component({
  components: {},
})
export default class CreateOrder extends AbpBase {
  @Prop({ type: Boolean, default: false })
  value: boolean;
  @Prop({
    type: Object,
    default: () => {
      return new Order();
    },
  })
  order: Order;
  postData = new PostData();
  tabName: string = "court";
  phoneNumber: string = "";
  offers: any = [];
  courtList: any = [];
  orderContent: string = "";
  supplierList: Array<any> = [];
  payMethods: Array<Object> = [
    {
      label: "球场现付",
      value: 0,
    },
    {
      label: "全额预付",
      value: 1,
    },
    {
      label: "部分预付",
      value: 2,
    },
  ];
  payTypeList: Array<Object> = [
    {
      label: "未支付",
      value: 0,
    },
    {
      label: "支付完成",
      value: 1,
    },
  ];
  orderStateList: Array<any> = [
    {
      label: "待确认",
      value: 0,
    },
    {
      label: "待付款",
      value: 1,
    },
    {
      label: "支付完成",
      value: 2,
    },
    {
      label: "搁浅申请",
      value: 3,
    },
    {
      label: "申请退款",
      value: 4,
    },
    {
      label: "退款完成",
      value: 5,
    },
    {
      label: "拒绝退款",
      value: 6,
    },
  ];
  regex = /(\S+),\s*(\d{4}-\d{2}-\d{2}),\s*(\d{1,2}:\d{2}),\s*(\d+)位:\s*(.+)/;
  /**
   * @description：订单内容回调
   */
  contentChange() {
    const match = this.orderContent.match(this.regex);
    if (match) {
      const dataObject = {
        courtName: match[1],
        date: match[2],
        teeTime: match[3],
        personCount: parseInt(match[4], 10),
        personNames: match[5],
      };
      this.getCourtList(dataObject.courtName);
      this.postData.teeTime = moment(
        `${dataObject.date} ${dataObject.teeTime}`
      ).format("YYYY-MM-DD HH:mm:ss");
      this.postData.personCount = dataObject.personCount;
      this.postData.personNames = dataObject.personNames;
    } else {
      this.$Message.error({
        content: "输入格式不满足要求,请检查,请确保输入英文,",
      });
    }
  }

  getTime(value) {
    return Util.int2time(value);
  }

  cancel() {
    this.$emit("input", false);
  }
  getSourceType(type) {
    if (type == 0) {
      return "小程序";
    } else if (type == 1) {
      return "Pc";
    } else if (type == 2) {
      return "App";
    } else if (type == 3) {
      return "H5";
    } else if (type == 4) {
      return "其他";
    }
  }
  closeTable() {
    this.$emit("input", false);
    this.$emit("getPage");
  }
  /**
   * @description:校验选择报价
   */
   checkProductId(rule: any, value: any, callback: any) {
    if (!this.postData.productId) {
      callback(new Error("请选择名称"));
    } else {
      callback();
    }
  }
  /**
   * @description:校验选择球场
   */
  checkCourtId(rule: any, value: any, callback: any) {
    if (!this.postData.courtId) {
      callback(new Error("请选择球场"));
    } else {
      callback();
    }
  }
  /**
   * @description:校验打球时间
   */
  checkTeeDate(rule: any, value: any, callback: any) {
    if (!this.postData.teeTime) {
      callback(new Error("请选择打球时间"));
    } else {
      callback();
    }
  }
  /**
   * @description:校验打款方
   */
  checkSupplierId(rule: any, value: any, callback: any) {
    if (!this.postData.supplierId) {
      callback(new Error("请选择付款方"));
    } else {
      callback();
    }
  }
  checkpayeeId(rule: any, value: any, callback: any) {
    if (!this.postData.payeeId) {
      callback(new Error("请选择收款方"));
    } else {
      callback();
    }
  }
  checkPrice(rule: any, value: any, callback: any) {
    if (!this.postData.price) {
      callback(new Error("请录入价格"));
    } else {
      callback();
    }
  }
  changeOrderType(type){
    this.postData.orderType=type;
    this.getCourtList();

  }
  get orderTypeList() {
    return this.$store.state.common.orderTypes;
  }

  /**
   * @description:表单校验规则
   */
  postDataRule = {
    productId: [
      {
        required: true,
        validator: this.checkProductId,
        trigger: "change",
      },
    ],
   
    teeTime: [
      {
        required: true,
        validator: this.checkTeeDate,
        trigger: "change",
      },
    ],
    supplierId: [
      {
        required: true,
        validator: this.checkSupplierId,
        trigger: "change",
      },
    ],
    payeeId: [
      {
        required: true,
        validator: this.checkpayeeId,
        trigger: "change",
      },
    ],

    personNames: [
      {
        required: true,
        message: "请输入打球人员姓名,用,分隔",
        trigger: "blur",
      },
    ],
    linkMan: [
      {
        required: true,
        message: "请输入联系人",
        trigger: "blur",
      },
    ],
    personCount: [
      {
        type: "number",
        required: true,
        min: 1,
        message: "请输入打球人数",
        trigger: "change",
      },
    ],
  };
  /**
   * @description:确定事件
   */
  save() {
    (this.$refs.postDataForm as any).validate(async (valid: boolean) => {
      if (this.postData.orderType != 0) {
          this.postData.teeTime = "";
        }
      if (valid) {
        await Ajax.post(
          "/api/services/app/Order/CreateOfflineOrder",
          this.postData
        )
          .then((res) => {
            if (res) {
              this.$Message.success({
                content: "添加线下订单成功",
              });
              this.closeTable();
            }
          })
          .catch(() => {
            this.$Message.error({
              content: "遇到错误,请联系管理员",
            });
            this.closeTable();
          });
      }
    });
  }
  /**
   * @description:弹窗发生改变事件
   */
  async visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
      this.postData = new PostData();
      this.$emit("getPage");
    } else {
      this.getCourtList();
      this.getSupplierList();
    }
  }
  /**
   * @description:获取供应商列表
   */
  async getSupplierList() {
    return await this.$store
      .dispatch({
        type: "supplier/GetAllSupplierListLabelAndValue",
      })
      .then((res) => {
        if (res && res.data && res.data.result) {
          this.supplierList = res.data.result;
        }
      });
  }
  /**
   * @description:获取全部球场列表
   */
  async getCourtList(name?: String) {
    let params = {
      orderType:this.postData.orderType
    };
    if (name && name.length > 0) {
      params["name"] = name;
    }
    let reponse = await Ajax.get( "/api/services/app/Order/GetLableAndValueByOrderType", {
      params,
    });
    this.courtList = reponse.data.result;
  }
  /**
   * @description:获取日期类型
   */
  getDateType(type) {
    switch (type) {
      case 8:
        return "平日";
      case 9:
        return "假日";
      case 10:
        return "特殊日期";
      case 11:
        return "周末";
      case 12:
        return "周日";
      case 13:
        return "周一";
      case 14:
        return "周二";
      case 15:
        return "周三";
      case 16:
        return "周四";
      case 17:
        return "周五";
      case 18:
        return "周六";
      default:
        return "未知";
    }
  }
  /**
   * @description:获取球场回调
   */
  getCourtId(obj) {
    if (obj && obj.value > 0) {
      this.postData.courtId = obj.value;
      this.postData.name = obj.label;
    }
  }
  /**
   * @description:获取时间回调
   */
  async getTeeDate(e) {
    this.postData.teeTime = e;
  }
}
